export const rollbarConfig = {
  accessToken: '013b60067310451f994c16be7cf56f1f',
  environment: process.env.NODE_ENV === 'development' ? 'development' : 'production',
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: {
    scriptEnv: 'clientApp',
  },
}
